import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button, Input, Form, Select, message } from 'antd';
import { scoutChatCenterServerUrl } from '../autoConfig';

const UpdateTeam = ({ onConsultantAdd }) => {
  const [form] = Form.useForm();
  const [teamOptions, setTeamOptions] = useState([]);
  const [allOptions, setAllOptions] = useState([]);
  const [curName, setCurName] = useState([]);
  const [teamName, setTeamName] = useState([]);
  const [teamEmail, setTeamEmail] = useState([]);
  const [frequentSentences, setFrequentSentences] = useState([]);
  const [emailValue, setEmailValue] = useState([]);
  const [coverage, setCoverage] = useState([]);
  const [debtorOptions, setDebtorOptions] = useState([]); // New state for debtor IDs
  const [messageApi, contextHolder] = message.useMessage();

  // Fetch debtor IDs
  const fetchDebtorIds = async () => {
    try {
      const response = await axios({
        method: 'get',
        url: `${scoutChatCenterServerUrl}/debtor/getAllDebtors`
      });
      setDebtorOptions(
        response.data.debtors.map((debtorId) => ({
          label: debtorId,
          value: debtorId
        }))
      );
    } catch (error) {
      console.log(error);
      messageApi.open({
        type: 'error',
        content: 'Failed to fetch debtor IDs!'
      });
    }
  };

  const onFinish = async (values) => {
    // Trim whitespace from teamName
    const cleanedValues = {
      ...values,
      teamEmail: values.teamEmail?.trim()
    };

    console.log(cleanedValues);
    try {
      const response = await axios({
        method: 'put',
        url: `${scoutChatCenterServerUrl}/team/updateTeam/${curName}`,
        data: {
          ...cleanedValues
        }
      });
      if (response) {
        window.location.reload();
      }
      return response;
    } catch (error) {
      messageApi.open({
        type: 'error',
        content: error.response?.data.message
      });
      return [];
    }
  };

  const handleChange = (value) => {
    const selectedTeam = allOptions.find((item) => item.teamName === value);
    setCurName(selectedTeam.teamName);

    if (selectedTeam) {
      setTeamName(selectedTeam.teamName || []);
      setTeamEmail(selectedTeam.teamEmail || []);
      setEmailValue(selectedTeam.teamAdmins || []);
      setCoverage(selectedTeam.teamCoverage || []);
      setFrequentSentences(selectedTeam.frequentSentences || []);

      form.setFieldsValue({
        teamAdmins: selectedTeam.teamAdmins || [],
        teamCoverage: selectedTeam.teamCoverage || [],
        teamEmail: selectedTeam.teamEmail || [],
        frequentSentences: selectedTeam.frequentSentences || []
      });
    }
  };

  const handleTeamEmail = (value) => {
    setTeamEmail(value);
  };

  const handleEmailChange = (value) => {
    setEmailValue(value);
  };

  const handleCoverageChange = (value) => {
    setCoverage(value);
  };

  const validateTeamName = (rule, value) => {
    if (allOptions.some((team) => team.teamName === value)) {
      return Promise.reject('This team name is already taken!');
    }
    return Promise.resolve();
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios({
          method: 'get',
          url: `${scoutChatCenterServerUrl}/team/getTeams`
        });
        setTeamOptions(
          response.data.teams.map((item) => ({
            value: item.teamName,
            label: item.teamName
          }))
        );
        setAllOptions(response.data.teams);
        return response;
      } catch (error) {
        messageApi.open({
          type: 'error',
          content: error.message
        });
        return [];
      }
    };

    fetchData();
    fetchDebtorIds(); // Fetch debtor IDs on component mount
  }, []);

  return (
    <div>
      <Form
        layout={{
          labelCol: {
            span: 4
          },
          wrapperCol: {
            span: 14
          }
        }}
        form={form}
        onFinish={onFinish}
      >
        <Form.Item
          label="Select Team"
          rules={[
            {
              required: true,
              message: 'Please select your team!'
            }
          ]}
        >
          <Select
            showSearch
            options={teamOptions}
            placeholder="Search your team"
            onChange={(value) => handleChange(value)}
            filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
          />
        </Form.Item>
        <Form.Item
          name="newTeamName"
          label="New Team Name"
          rules={[
            {
              validator: validateTeamName
            }
          ]}
        >
          <Input placeholder="Team Name" />
        </Form.Item>
        <Form.Item
          name="teamEmail"
          label="Team Email"
          rules={[
            {
              required: true,
              message: 'Please input your team email!'
            }
          ]}
        >
          <Input placeholder="" value={emailValue} onChange={handleTeamEmail} />
        </Form.Item>
        <Form.Item
          name="teamAdmins"
          label="Team Admin Email"
          rules={[
            {
              required: true,
              message: 'Please input your teamAdmin!'
            }
          ]}
        >
          <Select
            value={emailValue}
            onChange={handleEmailChange}
            mode="tags"
            tokenSeparators={[',']}
            style={{
              width: '100%'
            }}
            placeholder="Please select"
          />
        </Form.Item>
        <Form.Item
          name="teamCoverage"
          label="DebtorId"
          rules={[
            {
              required: true,
              message: 'Please input your teamCoverage!'
            }
          ]}
        >
          <Select
            value={coverage}
            onChange={handleCoverageChange}
            mode="tags"
            tokenSeparators={[',']}
            style={{
              width: '100%'
            }}
            placeholder="Please select"
            options={debtorOptions}
          />
        </Form.Item>
        <Form.Item name="frequentSentences" label="Frequent Sentences">
          <Select
            value={frequentSentences}
            onChange={setFrequentSentences}
            mode="tags"
            style={{
              width: '100%'
            }}
            placeholder="Please select"
          />
        </Form.Item>
        <Form.Item className="flex justify-center">
          <Button htmlType="submit">Submit</Button>
        </Form.Item>
      </Form>
      {contextHolder}
    </div>
  );
};

export default UpdateTeam;
